// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart{height:200px;width:50%;padding-right:15px}@media screen and (max-width: 48em){.chart{width:auto;position:relative;max-width:100%}}\n", ""]);
// Exports
module.exports = exports;
